import React, { useEffect, useState } from 'react'
import '../styles/program.scss'



export default function Films({ films, moviearr, setMoviearr, setRegarr, setCinemaarr, setSelectedDate, menuClickHandler, showItem }) {
 
   

    const [isOpen, setIsOpen] = useState(false);
  
   

    function handleRegionArrrow() {
        setIsOpen((current) => !current);
    }

  

    function handleFilmClick(item) {
      //  console.log(item, 'item')
        if (moviearr.includes(item.name)) {
            setMoviearr(moviearr.filter(r => { return r !== item.name }))
           
        }
        else setMoviearr([...moviearr, item.name])
    }
 
    return (
        
        <div className=" dropdownContainer">
            
               
                       
            <div className="chooseRegion" style={{
                borderBottomLeftRadius: isOpen ? '0px' : '8px',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                borderBottomRightRadius: isOpen ? '0px' : '8px',
            }}>
                            <div
                                style={{
                        position: "relative", boxSizing: "border-box",top:'-1px'
                                
                        
                                }}
                            >
                    <p className='dropdownTitle' >{moviearr && moviearr.length === 1 ? moviearr[0] : moviearr?.length > 0 ? 'Valgte film' : 'Alle film'}</p>
                        {moviearr?.length > 0 && moviearr.length && < span className="one"> {moviearr.length } </span> }
                             
                    <button className='chooseBtn' style={{top:'1px'} }
                        onClick={() => { handleRegionArrrow(); menuClickHandler('film') }}
                                    
                                >
                        <p className={showItem === "film" ? "rotate down" : "rotate "}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
                                    <path d="M1.5 1L10 10L18.5 1" stroke="white" stroke-width="2" stroke-linecap="round" />
                                </svg>
                                    </p>
                                </button>
                            </div>
                {showItem === "film" && (
                    <div className={`scroll  ${showItem === "film" ? 'dropdown_show' : null}`}   >
                            {films && films.sort((a,b) =>  a.name > b.name ? 1 : -1).map((item, index) => (
                                item.name &&
                                <div key={index} style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    height: "44px",
                                        padding: "10px 10px 10px 16px", borderRadius: '6px',
                                     
                                        marginRight: '2px', width: '98%',marginBottom:'4px',
                                        backgroundColor: moviearr.length && moviearr.includes(item.name) ? '#3E455C' : ''

                                    }} onClick={() => handleFilmClick(item)}>
                                        <p className='dropdowns-lists'>{item.name}</p>
                                 
                                        {moviearr.length && moviearr.includes(item.name) ?
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <rect x="1" y="1" width="22" height="22" rx="3" stroke="white" stroke-width="2" />
                                                <path d="M7 11L11 16L17.5 7" stroke="white" stroke-width="2" stroke-linecap="round" />
                                            </svg>
                                            :
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <rect x="1" y="1" width="22" height="22" rx="3" stroke="white" stroke-width="2" />
                                            </svg>}
                                   
                                </div>
                            ))
                            }
                           
                       </div>
                            )}
                        </div>
                   
                    
                </div>
               

           
        )
}